"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bestBuysEdit = bestBuysEdit;
exports.bestBuysPage = bestBuysPage;
exports.bestBuysSave = bestBuysSave;
exports.getBestBuysDetail = getBestBuysDetail;
exports.toggleEnable = toggleEnable;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var querestUrl = '/xyGoodsActivityBestBuys';

// 超值选项保存
function bestBuysSave(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'post',
    data: data
  });
}
// 超值选项编辑
function bestBuysEdit(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'put',
    data: data
  });
}

// 获取超值选项详情
function getBestBuysDetail(id) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/' + id,
    method: 'get'
  });
}

// 超值选项分页
function bestBuysPage(query) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/page',
    method: 'get',
    params: query
  });
}

// 快捷切换活动启用状态
function toggleEnable(fnId, markForEnable) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/toggleEnable',
    method: 'put',
    params: {
      fnId: fnId,
      markForEnable: markForEnable
    }
  });
}